<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'DropDownRessource'
});
</script>
<template>
  <ka-container
    code="drop-down-ressource"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Container -->
    <ka-container
      code="container"
      :options="{
        click: componentInstance.containerClick,
        $state: { selected: componentInstance.$estDeplie.value === true }
      }"
      :selected="{ click: componentInstance.containerClickWhenSelected }">
      <!-- Titre -->
      <ka-container code="titre">
        <ka-text code="texte">
          <h3 v-html="t('dropDownRessource.container.titre.texte.value', `{0} `, [componentInstance.$title.value])" />
        </ka-text>
      </ka-container>
      <ka-icon
        code="icon"
        :options="{ $inheritState: { selected: true } }"
        value="i-fa-solid:angle-down" />
    </ka-container>
    <!-- Contenu -->
    <ka-container
      code="contenu"
      :options="{ hidden: componentInstance.$estDeplie.value === true ? false : null }">
      <ka-text code="text">
        <span v-html="componentInstance.$contentText.value" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { dropDownRessourceComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c41')
const component = dropDownRessourceComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  title?: Nullable<string>
  contentText?: Nullable<string>
  estDeplie?: Nullable<boolean>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  title: 'Titre',
  contentText: undefined,
  estDeplie: false,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:title',
  'update:contentText',
  'update:estDeplie'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    title: true,
    contentText: true,
    estDeplie: true
  }
})
</script>
